module.exports = __webpack_public_path__ + "img/13200.b2fde225.jpg";